import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootEl = document.getElementById('sponsorat-root');
const root = ReactDOM.createRoot(rootEl);
const foundationId = rootEl.getAttribute('data-foundation-id');
root.render(
  // <React.StrictMode>
  <App foundationId={foundationId} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
